import {
  List,
  Datagrid,
  NumberField,
  DateField,
  TopToolbar,
  ExportButton,
  FunctionField,
  ReferenceField,
  TextField,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Link, useParams } from "react-router-dom";
import {
  Chip,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import InventoryGraph from "./ProviderIventoryGraph";
import React from "react";

const createdFromChoises = [
  { id: "MANUALLY_ADMIN", name: "Administrateur" },
  { id: "MANUALLY_PROVIDER", name: "Prestataire" },
  { id: "OUTLET", name: "Exutoire" },
  { id: "ORDER", name: "Bon de commande" },
];

const createdFromMap: Record<
  string,
  "success" | "warning" | "error" | "primary"
> = {
  MANUALLY_ADMIN: "warning",
  MANUALLY_PROVIDER: "success",
  ORDER: "error",
  OUTLET: "primary",
};

const createdFromLabels: Record<string, string> = createdFromChoises.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {}
);

const InventoryListActions = () => {
  const { id } = useParams<{ id: string }>();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const handleGetInviteUrl = React.useCallback(async () => {
    try {
      const response = await dataProvider.getInviteUrl("providers", {
        id,
      });
      window.open(response, "_blank");
    } catch (error) {
      console.error(error);
      notify("Error fetching invite URL", { type: "error" });
    }
  }, [dataProvider, id, notify]);

  return (
    <TopToolbar>
      {id && (
        <>
          <Button
            component={Link}
            to={`/providerInventory/create?providerId=${id}`}
            variant="outlined"
            color="success"
            size="small"
          >
            Ajouter inventaire
          </Button>
          <Button
            onClick={handleGetInviteUrl}
            color="warning"
            variant="outlined"
            size="small"
          >
            Lien d'inventaire prestataire
          </Button>
        </>
      )}
      <ExportButton />
    </TopToolbar>
  );
};

const nbrChoices = [
  { id: "fullBinsCount", name: "Caisses pleines" },
  { id: "emptyBinsCount", name: "Caisses vides" },
];

const DetailsStats: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let preFilterValue: any = [];
  if (id) {
    preFilterValue = JSON.stringify([{ name: "provider", value: id }]);
  }

  const dataProvider = useDataProvider();
  const [counts, setCounts] = React.useState<Record<string, number>>({
    fullBinsCount: 0,
    emptyBinsCount: 0,
  });

  React.useEffect(() => {
    dataProvider
      .getList("provider-inventory", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "createdAt", order: "DESC" },
        meta: { preFilter: preFilterValue },
      })
      .then(({ data }) => {
        data.forEach((element) => {
          setCounts((prev) => ({
            ...prev,
            emptyBinsCount: element.emptyBinsCount,
          }));
          setCounts((prev) => ({
            ...prev,
            fullBinsCount: element.fullBinsCount,
          }));
        });
      });
  }, [dataProvider, preFilterValue]);

  return (
    <Stack direction="row" spacing={2} sx={{ mb: 2, mt: 2 }}>
      {nbrChoices.map(({ id, name }) => (
        <>
          <Card
            sx={{
              width: "100%",
              textAlign: "center",
              bgcolor: (theme) => theme.palette.background.paper,
            }}
          >
            <CardContent>
              <Typography variant="subtitle2">{name} sur le HUB</Typography>
              <Typography variant="h6">{counts[id]}</Typography>
            </CardContent>
          </Card>
        </>
      ))}
    </Stack>
  );
};

export const ProviderInventoryDetails: React.FC = (props) => {
  const { id } = useParams<{ id: string }>();
  let preFilterValue: any = [];
  if (id) {
    preFilterValue = JSON.stringify([{ name: "provider", value: id }]);
  }

  return (
    <>
      <DetailsStats />
      <List
        {...props}
        resource="provider-inventory"
        actions={<InventoryListActions />}
        sort={{ field: "createdAt", order: "DESC" }}
        queryOptions={{
          meta: { preFilter: preFilterValue },
        }}
        title="Inventaire du prestataire"
      >
        <Datagrid bulkActionButtons={false}>
          <ReferenceField
            label="Prestataire"
            source="provider"
            reference="providers"
            link={false}
          >
            <TextField source="internalCode" /> - <TextField source="name" />
          </ReferenceField>
          <NumberField source="fullBinsCount" label="Caisses pleines" textAlign="center" />
          <NumberField source="emptyBinsCount" label="Caisses vides" textAlign="center" />
          <DateField
            source="createdAt"
            label="Date création .inv"
            locales="fr-FR"
            options={{
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            }}
          />
          <FunctionField
            source="createdFrom"
            label="Ajouté par"
            render={(record) => {
              const label =
                createdFromLabels[record.createdFrom] || record.createdFrom;
              const color = createdFromMap[record.createdFrom] || "default";
              return <Chip label={label} color={color} size="small" />;
            }}
          />
          <TextField source="comment" label="Commentaire" />
        </Datagrid>
      </List>
      {id && <InventoryGraph providerId={id} />}
    </>
  );
};
